module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-One.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-14"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Chapter One")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_vm._v("Vaughn Cooper was not an easy man to like. There was a time when he’d been quicker with a smile or a joke, but twelve years in law enforcement and three years in the Unsolved Crimes Investigation Unit of the Texas Rangers had worn off any charm he’d been born with.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was not a man who believed in the necessity of small talk, politeness or pretending a situation was anything other than what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was most definitely not a man who believed in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hypnotism")]), _vm._v(", even if the woman currently putting their witness under acted both confident and capable.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He didn’t trust it, her or what she did, and he was more than marginally irritated that the witness seemed to immediately react. No more fidgeting, no more yelling that he didn’t know anything. After Natalie Torres’s ministrations, the man was still and pleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn didn’t believe it for a second.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I told you,” Bennet Stevens said, giving him a nudge. Bennet had been his partner for the past two years, and Vaughn liked him. Some days. This was not one of those days.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not real. He’s acting.” Vaughn made no effort to lower his voice. It was purposeful, and he watched carefully for any sign of reaction from the supposedly hypnotized witness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He didn’t catch any, but he could all but feel Ms. Torres’s angry gaze on him. He didn’t care if she was angry. All he cared about was getting to the bottom of this case before another woman disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wasn’t sure his weary conscience could take another thing piled on top of the overflowing heap.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How are you today, Mr. Herman?” Ms. Torres asked in that light, airy voice she’d hypnotized the man with. Vaughn rolled his eyes. That anyone would fall for this was beyond him. They were police officers. They dealt in evidence and reality, not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hypnotism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Been better,” the witness grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I see,” she continued, that easy, calming tone to her voice never changing. “Can you tell us a little bit about your problems?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You know, you’re safe here, Mr. Herman. You can speak freely. This is a safe place where you can unburden yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn tried to tamp down his edgy impatience. He couldn’t get over them wasting their time doing this, but it hadn’t been his call. This had come from above him, and he had no choice but to follow through.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The hypnotist inclined her head toward Vaughn and Bennet. It was the agreed upon sign that they would now take over the questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not a bad gig,” Herman said, his hands linked together on the table in front of him. No questions needed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yeah, Vaughn didn’t believe a second of this.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t have to get my hands too dirty. Paid cash. My old lady’s got cancer. Goes a long way, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Rough,” Bennet said, doing a far better job than Vaughn of infusing some sympathy into his tone. “What kind of jobs you running?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mostly just messages, you know. I don’t even gotta be the muscle. Just deliver the information. It’s a sweet deal. But...”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn could feel the hypnotist’s eyes on him. Something about her. Something about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(". It was all off. He wasn’t even being paranoid like Bennet too often accused him of. The witness was too easy, and the woman was too jumpy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But... Man, I don’t like this, though. I got a daughter of my own. I never wanted to get involved with this part.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What part’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The girls. He keeps the girls.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn tensed, and he noticed the hypnotist did, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Who keeps them?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn and Bennet whirled to face Ms. Torres. She wasn’t supposed to ask questions. Not after she gave them the signal. Not about the case.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What the hell do you think—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The Stallion,” Herman muttered. “But I can’t cross The Stallion.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn immediately looked at Bennet. He gave his partner an imperceptible nod, then Bennet slipped out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Stallion. An idiotic name for the head of an organized crime group that had been stealthily wreaking havoc across Texas for ten years. Vaughn had no less than four cases he knew connected to the bastard or his drug-running cronies, but this one...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you know about The Stallion?” Vaughn asked evenly, though frustration pounded in his bloodstream. Still, hypnotism or no hypnotism, he wasn’t the type of ranger who let that show.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t cross him. You don’t cross him and live.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn opened his mouth to ask the next question, but the damn hypnotist beat him to it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about the girls?” she demanded, leaning closer. “What do you know about the girls? Where are they?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn was so taken aback by her complete disregard for the rules, by her fervent demand, he couldn’t say anything at first. But it was only a split second of shock, then he edged his way between Ms. Torres and her line of sight to the witness.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Get him out,” he ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Big brown eyes blinked up at him. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If this is hypnotism, unhypnotize him.” Vaughn bent over and leaned his mouth close enough to her ear so he could whisper without the witness overhearing. “You are putting my case at risk, and I will not have it. Take him out now, or I’ll kick you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t waver, and she certainly didn’t turn to Herman and take him out. “I’m getting answers,” she replied through gritted teeth. Her eyes blazed with righteous fury.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was no match for his own. Vaughn inclined his head toward Herman, who was shaking his head back and forth. Not offering "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _vm._v(" answers to her too direct line of questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mr. Herman—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Vaughn nudged her chair back with his knee. “Take him out, or I’ll arrest you for interfering in a criminal investigation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her eyes glittered with that fury, her hands clenched into fists, but when he rested his hand on the handcuffs latched to his utility belt, she closed her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine, but you need to move.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When she opened her eyes, he saw a weary resignation in her slumped posture, a kind of sorrow in her expression Vaughn didn’t understand—didn’t want to. Any more than he wanted to figure out what scent she was wearing, because when he was this close to her, it was almost distracting.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Almost.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If you say one word to him that isn’t pulling him out of the hypnotism, you will be arrested. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I thought you didn’t believe in it?” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t, but I’m not going to have you claiming I didn’t let you do your job. Take him out. Then you will be talking to my supervisor. Got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sneered at him, like many a criminal he’d arrested or threatened in his career. He wasn’t sure she was a criminal, but he wasn’t affected at all by her anger.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d ruined the lead. The Stallion wasn’t nearly enough to go on, and she’d stepped in with her own reckless, desperate questions, invalidating the whole interrogation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was going to pay for this.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("ATALIE")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("SAT")]), _c('span', {
    staticClass: "sc"
  }), _c('span', {
    staticClass: "sc-epub"
  }, [_vm._v("IN")]), _c('span', {
    staticClass: "sc"
  }), _vm._v("the waiting area of the Unsolved Crimes office. She wanted to fume and rage and pace, but she didn’t have time to indulge in pointless anger. Not when she had information to find.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Who was The Stallion? Could this all possibly be related to her sister? She’d waited three years for this. Three years of dealing with sneering Texas Rangers hating that their higher-ups involved her in their investigations. Three years of hoping against hope that the next case she’d be brought in on would be Gabby’s.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Just because the witness had talked about missing girls didn’t mean it was her sister’s case. As a hypnotist, she was never given any case details, legally bound to secrecy regarding anything she did hear simply by being in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d lost her cool. She knew she wasn’t supposed to jump in like that, but the interrogators had been asking the wrong questions. They’d been taking too much time. She needed to know. She needed...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She needed not to cry. So, she took a deep breath in, and slowly let it out. She focused on the little window with the blinds closed. Inside, three officers were talking. Probably about her. One definitely complaining about her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was angry with herself for breaking rules she knew Texas Rangers weren’t going to bend, but she’d rather channel that anger onto Ranger Jerk.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Immature, yes, but the immature nicknames she gave each ranger who gave her a hard time entertained her when she wanted to tell them off.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The problem with Ranger Jerk was she could nearly forget what a jerk he was when he looked like..."), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(". He was so tall and broad shouldered, and when he was always crossing his arms over his chest in a threatening manner, it was obvious he had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muscles")]), _vm._v(" underneath the crisp white dress shirt he wore.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Like, the kind of muscles that could probably bench-press "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(". Not that she’d imagined that in those first few minutes of meeting him. Those were flights of fancy she did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" allow herself. Not on the job.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then there was his face, which wasn’t at all fair. She’d nearly been tongue-tied when he’d greeted her. His darkish blond hair was buzzed short, and his blue eyes were downright mesmerizing. Some light shade that was nearly gray, and she’d spent seconds trying to decide what to call that color.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Until he’d insulted her without a qualm. Because his good looks were only "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one")]), _vm._v(" problem with him. Only the tip of the iceberg of problems.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The door opened, and she forced herself to look calm and placid. She was a calm, still lake. No breeze rippled her waters. She reflected nothing but a peaceful and reflective surface.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But maybe a sea monster lurked deep and would leap out of the water and eat all of them in one giant gulp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yeah, her imagination had always gotten her into trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ms. Torres. Come inside, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She held no ill will against Captain Dean. He was one of the few rangers who respected and believed in what she did. He was, more often than not, the one who called her in to help with a case.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" crossed a line she knew she wasn’t supposed to cross, and she was going to have to deal with the consequences—which would gall. For one, because it meant Ranger Jerk got what he wanted. But more important, because she might have finally had some insight into her sister’s case, and been too impetuous to make the most of it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Have a seat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She slid into the chair opposite Captain Dean’s desk. The two rangers she’d been in the interrogation room with stood on either side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They were impressive, the three of them. Strong, in control, looking perfectly pressed in what constituted as the Texas Ranger uniform: khakis, a dress shirt and a tie, Ranger badge and belt buckle, topped off with cowboy boots. The only thing the men weren’t wearing inside the office were the white cowboy hats.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wanted to sneer at Ranger Cooper’s smug blue eyes, but she didn’t. She smiled sweetly instead.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You breached our contract, Ms. Torres. You know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your job is not to question witnesses. It’s only to put them under hypnosis, should they agree, to calm them and allow us to ask questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know, sir. I’m sorry for...stepping out of line.” She offered both the men who’d been in the room with her the best apologetic smile she could muster. “I got a little carried away. I can promise you, it won’t happen again.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m afraid we can’t risk second chances at this juncture. Not in this department, not in the Texas Rangers. I’m sorry, Natalie. You’ve been an asset. But this was unconscionable, and you will not be asked back.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sat frozen, completely ice from the inside out. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not be asked back.")]), _vm._v(" But she’d helped solve cases. For years. She’d received a commendation even! And he was...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cooper, see her out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ranger Jerk nodded toward the door. “After you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She swallowed over the lump in her throat. All her chances. All the times she’d been so close to seeing something of Gabby’s case. All the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("possibility")]), _vm._v(", and she’d ruined it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he’d")]), _vm._v(" ruined it for her. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" had. She stood on shaky legs, clutching her phone and her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I am sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t look back at Captain Dean, or Ranger Stevens. She didn’t want to see the pitying, apologetic looks on their faces. Just like all those other policemen who’d come up with nothing—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nothing")]), _vm._v(" when it came to Gabby’s disappearance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Apologies didn’t mean a thing when her sister was gone. Eight years. And Natalie was the only one who held out any hope, and now her hope was...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Well, it had just gotten kicked in the teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She managed to walk stiffly to the door and stepped out, the Jerk of the Manor still behind her. Too close behind her and crowding her out and away.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll see you all the way out of the building, Ms. Torres,” he said, sounding so smug and superior.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She walked down the hall, still a little shaken. But shaken had no hold on her anger. She glared at the man striding next to her. “You got me fired, you lousy son of a—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d reconsider your line of thought and blame, Ms. Torres.” He continued to look ahead, not an ounce of emotion showing on his face. “You got yourself fired. Now, stay out of this case. If I catch a whiff of you being involved in it anywhere, I will not hesitate to find out every last thing about you and connect you to whatever dirty deeds you’re hiding.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I am not hiding any dirty deeds.” Which was the God’s honest truth. She hadn’t stepped out of line in eight years. Or ever, really, but especially since Gabby had disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His eyes met hers, a cold, cold stormy blue. “We’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shivered involuntarily, because that look made her feel like she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" done something wrong, which was so absurd.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Even more absurd was the idea of her staying out of the case. She’d take what little information she’d gathered and follow it to the ends of the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Because she refused to believe her sister was dead. A body had never been found, and that Herman man had said...he’d said "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he keeps the girls")]), _vm._v(". Not kept. Not got rid of. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Keeps")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maybe Gabby wasn’t one of those girls, but it was possible. More than that, she thought. The Texas Rangers might be a mostly good bunch, but they had rules and regulations to follow. Natalie Torres did not.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("God help the man who tried to stop her.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-10"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18325b32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_One.vue
// module id = 81
// module chunks = 0